/* eslint-disable max-len */
const adHomepageLD =
	process.env.NEXT_PUBLIC_AD_HOMEPAGE_LEADERBOARD &&
	process.env.NEXT_PUBLIC_AD_HOMEPAGE_LEADERBOARD.split('~~');
const adHomepageMH =
	process.env.NEXT_PUBLIC_AD_HOMEPAGE_MOBILE_HALFBANNER &&
	process.env.NEXT_PUBLIC_AD_HOMEPAGE_MOBILE_HALFBANNER.split('~~');
const adHomepageHP =
	process.env.NEXT_PUBLIC_AD_HOMEPAGE_HALFPAGE &&
	process.env.NEXT_PUBLIC_AD_HOMEPAGE_HALFPAGE.split('~~');
const adHomepageMR =
	process.env.NEXT_PUBLIC_AD_HOMEPAGE_MEDIUMREC &&
	process.env.NEXT_PUBLIC_AD_HOMEPAGE_MEDIUMREC.split('~~');
const adCtgArticleLLD =
	process.env.NEXT_PUBLIC_AD_CTG_ARTICLE_LLEADERBOARD &&
	process.env.NEXT_PUBLIC_AD_CTG_ARTICLE_LLEADERBOARD.split('~~');
const adCtgArticleHP =
	process.env.NEXT_PUBLIC_AD_CTG_ARTICLE_HALFPAGE &&
	process.env.NEXT_PUBLIC_AD_CTG_ARTICLE_HALFPAGE.split('~~');
const adCtgArticleMR =
	process.env.NEXT_PUBLIC_AD_CTG_ARTICLE_MEDIUMREC &&
	process.env.NEXT_PUBLIC_AD_CTG_ARTICLE_MEDIUMREC.split('~~');
const adDtlArticleLLD =
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_LLEADERBOARD &&
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_LLEADERBOARD.split('~~');
const adDtlArticleLD =
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_LEADERBOARD &&
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_LEADERBOARD.split('~~');
const adDtlArticleHP =
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_HALFPAGE &&
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_HALFPAGE.split('~~');
const adDtlArticleMR =
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_MEDIUMREC &&
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_MEDIUMREC.split('~~');
const adCtgArticleMB =
	process.env.NEXT_PUBLIC_AD_CTG_ARTICLE_MOBILE_BANNER &&
	process.env.NEXT_PUBLIC_AD_CTG_ARTICLE_MOBILE_BANNER.split('~~');
const adCtgArticleMH =
	process.env.NEXT_PUBLIC_AD_CTG_ARTICLE_MOBILE_HALFBANNER &&
	process.env.NEXT_PUBLIC_AD_CTG_ARTICLE_MOBILE_HALFBANNER.split('~~');
const adDtlArticleMB =
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_MOBILE_BANNER &&
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_MOBILE_BANNER.split('~~');
const adDtlArticleMH =
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_MOBILE_HALFBANNER &&
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_MOBILE_HALFBANNER.split('~~');
const adDtlArticleMM =
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_MOBILE_MEDIUMREC &&
	process.env.NEXT_PUBLIC_AD_DTL_ARTICLE_MOBILE_MEDIUMREC.split('~~');

const global = {
	ERRORPAGE: {
		404: {
			title: 'Halaman Tidak Ditemukan',
			description:
				'Wah halaman yang kamu cari tidak ditemukan nih! balik ke <br />halaman sebelumnya aja ya.',
		},
		500: {
			title: 'Terjadi Kesalahan',
			description:
				'Sepertinya ada kesalahan dari sistem HalloBumil. Kamu bisa coba <br />beberapa saat lagi ya.',
		},
	},
	WEB_ENV: process.env.NEXT_PUBLIC_WEB_ENV,
	AD: {
		HOMEPAGE_LEADERBOARD_UNIT: adHomepageLD && adHomepageLD[0],
		HOMEPAGE_LEADERBOARD_SIZE: adHomepageLD ? JSON.parse(adHomepageLD[1]) : [],
		HOMEPAGE_MOBILE_HALFBANNER_UNIT: adHomepageMH && adHomepageMH[0],
		HOMEPAGE_MOBILE_HALFBANNER_SIZE: adHomepageMH ? JSON.parse(adHomepageMH[1]) : [],
		HOMEPAGE_HALFPAGE_UNIT: adHomepageHP && adHomepageHP[0],
		HOMEPAGE_HALFPAGE_SIZE: adHomepageHP ? JSON.parse(adHomepageHP[1]) : [],
		HOMEPAGE_MEDIUMREC_UNIT: adHomepageMR && adHomepageMR[0],
		HOMEPAGE_MEDIUMREC_SIZE: adHomepageMR ? JSON.parse(adHomepageMR[1]) : [],
		CTG_ARTICLE_LLEADERBOARD_UNIT: adCtgArticleLLD && adCtgArticleLLD[0],
		CTG_ARTICLE_LLEADERBOARD_SIZE: adCtgArticleLLD ? JSON.parse(adCtgArticleLLD[1]) : [],
		CTG_ARTICLE_HALFPAGE_UNIT: adCtgArticleHP && adCtgArticleHP[0],
		CTG_ARTICLE_HALFPAGE_SIZE: adCtgArticleHP ? JSON.parse(adCtgArticleHP[1]) : [],
		CTG_ARTICLE_MEDIUMREC_UNIT: adCtgArticleMR && adCtgArticleMR[0],
		CTG_ARTICLE_MEDIUMREC_SIZE: adCtgArticleMR ? JSON.parse(adCtgArticleMR[1]) : [],
		DTL_ARTICLE_LLEADERBOARD_UNIT: adDtlArticleLLD && adDtlArticleLLD[0],
		DTL_ARTICLE_LLEADERBOARD_SIZE: adDtlArticleLLD ? JSON.parse(adDtlArticleLLD[1]) : [],
		DTL_ARTICLE_LEADERBOARD_UNIT: adDtlArticleLD && adDtlArticleLD[0],
		DTL_ARTICLE_LEADERBOARD_SIZE: adDtlArticleLD ? JSON.parse(adDtlArticleLD[1]) : [],
		DTL_ARTICLE_HALFPAGE_UNIT: adDtlArticleHP && adDtlArticleHP[0],
		DTL_ARTICLE_HALFPAGE_SIZE: adDtlArticleHP ? JSON.parse(adDtlArticleHP[1]) : [],
		DTL_ARTICLE_MEDIUMREC_UNIT: adDtlArticleMR && adDtlArticleMR[0],
		DTL_ARTICLE_MEDIUMREC_SIZE: adDtlArticleMR ? JSON.parse(adDtlArticleMR[1]) : [],
		CTG_ARTICLE_MOBILE_BANNER_UNIT: adCtgArticleMB && adCtgArticleMB[0],
		CTG_ARTICLE_MOBILE_BANNER_SIZE: adCtgArticleMB ? JSON.parse(adCtgArticleMB[1]) : [],
		CTG_ARTICLE_MOBILE_HALFBANNER_UNIT: adCtgArticleMH && adCtgArticleMH[0],
		CTG_ARTICLE_MOBILE_HALFBANNER_SIZE: adCtgArticleMH ? JSON.parse(adCtgArticleMH[1]) : [],
		DTL_ARTICLE_MOBILE_BANNER_UNIT: adDtlArticleMB && adDtlArticleMB[0],
		DTL_ARTICLE_MOBILE_BANNER_SIZE: adDtlArticleMB ? JSON.parse(adDtlArticleMB[1]) : [],
		DTL_ARTICLE_MOBILE_HALFBANNER_UNIT: adDtlArticleMH && adDtlArticleMH[0],
		DTL_ARTICLE_MOBILE_HALFBANNER_SIZE: adDtlArticleMH ? JSON.parse(adDtlArticleMH[1]) : [],
		DTL_ARTICLE_MOBILE_MEDIUMREC_UNIT: adDtlArticleMM && adDtlArticleMM[0],
		DTL_ARTICLE_MOBILE_MEDIUMREC_SIZE: adDtlArticleMM ? JSON.parse(adDtlArticleMM[1]) : [],
	},
};

export default global;
